export const PROFILE_FAIL = 'GET_PROFILE_FAIL'
export const PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const PROFILE_LOADING = 'GET_PROFILE_LOADING'

export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_LOADING = 'UPDATE_PROFILE_LOADING'

export const DELETE_PROFILE_FIELDS_FAIL = 'DELETE_PROFILE_FIELDS_FAIL'
export const DELETE_PROFILE_FIELDS_SUCCESS = 'DELETE_PROFILE_FIELDS_SUCCESS'
export const DELETE_PROFILE_FIELDS_LOADING = 'DELETE_PROFILE_FIELDS_LOADING'

export const PROFILES_FAIL = 'GET_PROFILES_FAIL'
export const PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS'
export const PROFILES_LOADING = 'GET_PROFILES_LOADING'

export const GET_GITREPOS_FAIL = 'GET_GET_GITREPOS_FAIL'
export const GET_GITREPOS_SUCCESS = 'GET_GET_GITREPOS_SUCCESS'
export const GET_GITREPOS_LOADING = 'GET_GET_GITREPOS_LOADING'

export const GET_PROFILEBYUSERNAME_FAIL = 'GET_GET_PROFILEBYUSERNAME_FAIL'
export const GET_PROFILEBYUSERNAME_SUCCESS = 'GET_GET_PROFILEBYUSERNAME_SUCCESS'
export const GET_PROFILEBYUSERNAME_LOADING = 'GET_GET_PROFILEBYUSERNAME_LOADING'
